export enum ViewerUrlTypeEnum {
    PDF = 'PDF'
}
